<template>
  <div>
    <v-snackbar
      app
      top
      transition="scale-transition"
      :value="updateExists"
      :timeout="-1"
      :class="$store.getters.LANGUAGE == 'fa' ? 'vazir-font-fd' : 'vazir-font'"
    >
      {{ $vuetify.lang.translator("updateAvailable") }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="#4CAF50" v-bind="attrs" @click="refreshApp()">
          {{ $vuetify.lang.translator("update") }}
        </v-btn>
      </template>
    </v-snackbar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    refreshing: false,
    registration: null,
    updateExists: false
  }),
  created() {
    var token = this.$store.getters.ACCESSTOKEN;
    if (token) {
      this.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true
    });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  methods: {
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },

    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) return;
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  }
};
</script>
